import { useState } from "react";

const CITIES = [
  { id: "paris", label: "Paris", multiplier: 1.25 },
  { id: "boulogne", label: "Boulogne-Billancourt", multiplier: 1.20 },
  { id: "argenteuil", label: "Argenteuil", multiplier: 1.15 },
  { id: "montreuil", label: "Montreuil", multiplier: 1.15 },
  { id: "lyon", label: "Lyon", multiplier: 1.10 },
  { id: "villeurbanne", label: "Villeurbanne", multiplier: 1.08 },
  { id: "strasbourg", label: "Strasbourg", multiplier: 1.08 },
  { id: "bordeaux", label: "Bordeaux", multiplier: 1.05 },
  { id: "nantes", label: "Nantes", multiplier: 1.05 },
  { id: "lille", label: "Lille", multiplier: 1.05 },
  { id: "nice", label: "Nice", multiplier: 1.05 },
  { id: "grenoble", label: "Grenoble", multiplier: 1.05 },
  { id: "aix", label: "Aix-en-Provence", multiplier: 1.03 },
  { id: "rennes", label: "Rennes", multiplier: 1.03 },
  { id: "roubaix", label: "Roubaix", multiplier: 1.03 },
  { id: "rouen", label: "Rouen", multiplier: 1.02 },
  { id: "marseille", label: "Marseille", multiplier: 1.0 },
  { id: "toulouse", label: "Toulouse", multiplier: 1.0 },
  { id: "montpellier", label: "Montpellier", multiplier: 1.0 },
  { id: "reims", label: "Reims", multiplier: 1.0 },
  { id: "toulon", label: "Toulon", multiplier: 1.0 },
  { id: "dijon", label: "Dijon", multiplier: 1.0 },
  { id: "angers", label: "Angers", multiplier: 1.0 },
  { id: "nimes", label: "Nîmes", multiplier: 1.0 },
  { id: "brest", label: "Brest", multiplier: 1.0 },
  { id: "lemans", label: "Le Mans", multiplier: 1.0 },
  { id: "amiens", label: "Amiens", multiplier: 1.0 },
  { id: "tours", label: "Tours", multiplier: 1.0 },
  { id: "limoges", label: "Limoges", multiplier: 1.0 },
  { id: "clermont", label: "Clermont-Ferrand", multiplier: 1.0 },
  { id: "metz", label: "Metz", multiplier: 1.0 },
  { id: "besancon", label: "Besançon", multiplier: 1.0 },
  { id: "orleans", label: "Orléans", multiplier: 1.0 },
  { id: "caen", label: "Caen", multiplier: 1.0 },
  { id: "mulhouse", label: "Mulhouse", multiplier: 1.0 },
  { id: "perpignan", label: "Perpignan", multiplier: 1.0 },
  { id: "nancy", label: "Nancy", multiplier: 1.0 },
];

const CLIENT_TYPES = [
  { id: "grand_groupe", label: "🏢 Grand groupe / CAC40", desc: "Budget élevé, process longs", multiplier: 1.35 },
  { id: "eti", label: "🏬 ETI", desc: "250–5 000 salariés", multiplier: 1.20 },
  { id: "agence", label: "🎯 Agence", desc: "Sous-traitance ou collab", multiplier: 1.15 },
  { id: "pme", label: "🏪 PME", desc: "10–250 salariés", multiplier: 1.0 },
  { id: "startup", label: "🚀 Startup", desc: "Budget variable, croissance rapide", multiplier: 1.15 },
  { id: "tpe", label: "🛖 TPE / Petite entreprise", desc: "Moins de 10 salariés", multiplier: 0.85 },
  { id: "solopreneur", label: "🙋 Indépendant / Solopreneur", desc: "Budget serré, relation directe", multiplier: 0.75 },
  { id: "asso", label: "🤲 Association / Secteur public", desc: "Budget contraint, impact fort", multiplier: 0.80 },
];

const EXPERTISE_LEVELS = [
  { id: "junior", label: "Junior", years: "0–2 ans", tjm: 200, retainer: 800, forfait: 500, formation: 350, highticket: 800, lowticket: 197, color: "#a78bfa", note: "Moy. marché : ~236 €/j" },
  { id: "intermediaire", label: "Intermédiaire", years: "3–7 ans", tjm: 310, retainer: 1400, forfait: 900, formation: 550, highticket: 1500, lowticket: 297, color: "#7c3aed", note: "Moy. marché : 298–407 €/j" },
  { id: "confirme", label: "Confirmé", years: "8–15 ans", tjm: 430, retainer: 2000, forfait: 1400, formation: 750, highticket: 3000, lowticket: 497, color: "#5b21b6", note: "Moy. marché : 401–525 €/j" },
  { id: "expert", label: "Expert / Référent", years: "15+ ans", tjm: 600, retainer: 3000, forfait: 2000, formation: 950, highticket: 6000, lowticket: 797, color: "#3b0764", note: "Marché : jusqu'à 1 500 €/j" },
];

const SPECIALTIES = [
  { id: "social", label: "📱 Social Media / CM", bonus: 0 },
  { id: "content", label: "✍️ Copywriting / Content", bonus: 30 },
  { id: "strategy", label: "🧠 Stratégie com'", bonus: 80 },
  { id: "branding", label: "🎨 Branding / Identité", bonus: 60 },
  { id: "da", label: "🖼 Direction artistique", bonus: 90 },
  { id: "design", label: "🖌️ Design / Figma / UI", bonus: 65 },
  { id: "webdesign", label: "🌐 Web design / Création de site", bonus: 55 },
  { id: "linkedin", label: "💼 LinkedIn B2B", bonus: 70 },
  { id: "seo", label: "🔍 SEO", bonus: 60 },
  { id: "growth", label: "📈 Growth Hacking", bonus: 75 },
  { id: "ia", label: "🤖 IA / Agents", bonus: 120 },
  { id: "ads", label: "📣 Media Paid / Ads", bonus: 70 },
  { id: "email", label: "📧 Email marketing", bonus: 50 },
  { id: "influence", label: "🌟 Influence / UGC", bonus: 40 },
  { id: "video", label: "🎬 Vidéo / Réels", bonus: 55 },
  { id: "podcast", label: "🎧 Podcast / Audio", bonus: 45 },
  { id: "rp", label: "📰 RP / Relations presse", bonus: 55 },
  { id: "community", label: "🤝 Community building", bonus: 40 },
  { id: "personal", label: "🙋 Personal branding", bonus: 60 },
  { id: "vente", label: "💰 Vente / Closing", bonus: 65 },
  { id: "event", label: "🎪 Event marketing", bonus: 50 },
  { id: "admin", label: "🗂 Admin / OBM / Assistante digitale", bonus: 20 },
];

const OFFERS = [
  { id: "tjm", label: "Mission ponctuelle (TJM)", key: "tjm", unit: "/ jour", desc: "Intervention one-shot sur une journée ou quelques jours" },
  { id: "retainer", label: "Accompagnement mensuel", key: "retainer", unit: "/ mois", desc: "Présence régulière, suivi continu, facturation mensuelle fixe" },
  { id: "forfait", label: "Projet à périmètre fixe", key: "forfait", unit: "/ projet", desc: "Livrable défini (site, audit, stratégie…), délai et prix convenus à l'avance" },
  { id: "formation", label: "Formation / Atelier présentiel ou live", key: "formation", unit: "/ jour", desc: "Session de transmission en groupe, présentiel ou visio" },
  { id: "highticket", label: "Coaching / Formation high-ticket", key: "highticket", unit: "/ programme", desc: "Accompagnement premium individuel ou petit groupe, forte valeur perçue" },
  { id: "lowticket", label: "Formation low/mid-ticket (infoproduit)", key: "lowticket", unit: "/ programme", desc: "Contenu enregistré ou parcours en autonomie, scalable" },
];

const EXTRAS = [
  { id: "portfolio", label: "Portfolio solide", bonus: 20 },
  { id: "niche", label: "Niche spécialisée", bonus: 40 },
  { id: "temoignages", label: "Témoignages clients", bonus: 20 },
  { id: "english", label: "Bilingue FR/EN", bonus: 30 },
  { id: "ia", label: "Maîtrise des outils IA", bonus: 30 },
  { id: "notoriete", label: "Notoriété / Audience", bonus: 50 },
];

const SOURCES = [
  { label: "ABC Portage — TJM Community Manager par niveau d'expérience", url: "https://www.abcportage.fr/portage-salarial/simulation-revenus/tjm/tjm-community-manager/" },
  { label: "Malt — Grille des tarifs Community Manager 2026", url: "https://www.malt.fr/t/barometre-tarifs/communication/community-manager" },
  { label: "Malt — Grille des tarifs Consultant en communication 2026", url: "https://www.malt.fr/t/barometre-tarifs/communication/consultant-en-communication" },
  { label: "La Fabrique du Net — Tarifs Community Manager freelance 2025", url: "https://www.lafabriquedunet.fr/tarif-community-manager-couts-et-prestations-types/" },
  { label: "LiveMentor — Comment fixer ses tarifs en tant que CM freelance", url: "https://www.livementor.com/blog/fixer-tarifs-community-manager/" },
  { label: "FreelanceRepublik — TJM Freelance : calcul & tarifs 2025", url: "https://talks.freelancerepublik.com/tjm-freelance-guide/" },
  { label: "Free-Work — TJM Community Manager / Social Media Manager", url: "https://www.free-work.com/fr/tech-it/community-manager-social-media-manager/rate-tjm-freelance" },
  { label: "2iPortage — Baromètre des tarifs freelance par secteur et région", url: "https://www.2iportage.com/barometre-des-tarifs-freelances-et-consultants/" },
  { label: "Jedha — Salaire et TJM Growth Hacker freelance France 2025", url: "https://www.jedha.co/formation-data/salaire-moyen-growth-hacker" },
  { label: "Koino — Tarifs consultant IA freelance France 2025", url: "https://www.koino.fr/articles/comment-recruter-un-consultant-ia-freelance-en-2025-prix-methode-comparatif" },
  { label: "RH Solutions — TJM freelances tech & design 2025", url: "https://www.rh-solutions.com/le-grand-guide-du-portage/tjm-freelance-tech-2025/" },
  { label: "Deux.io — Tarifs agence communication PME vs grands groupes 2025", url: "https://deux.io/tarif-agence-communication/" },
];

const STEPS = ["Ville", "Client", "Expérience", "Spécialités", "Offre", "Atouts", "Résultat"];

const H2 = ({ children }) => (
  <h2 style={{ fontFamily: "'Inter', sans-serif", fontSize: 22, fontWeight: 800, color: "#1e1b4b", marginBottom: 4, letterSpacing: "-0.02em" }}>{children}</h2>
);
const Tag = ({ label }) => (
  <span style={{ fontSize: 11, fontWeight: 700, background: "#ede9fe", color: "#7c3aed", borderRadius: 999, padding: "3px 10px" }}>{label}</span>
);

export default function PricingCalculator() {
  const [gated, setGated] = useState(true); // gate screen shown first
  const [step, setStep] = useState(0);
  const [city, setCity] = useState(null);
  const [citySearch, setCitySearch] = useState("");
  const [clientTypes, setClientTypes] = useState([]);
  const toggleClientType = (id) =>
    setClientTypes((prev) => prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]);
  const [expertise, setExpertise] = useState(null);
  const [specialties, setSpecialties] = useState([]);
  const [offer, setOffer] = useState(null);
  const [extras, setExtras] = useState([]);
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState([]);
  const [showSources, setShowSources] = useState(false);

  const toggleSpecialty = (id) =>
    setSpecialties((prev) => prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]);
  const toggleExtra = (id) =>
    setExtras((prev) => prev.includes(id) ? prev.filter((e) => e !== id) : [...prev, id]);

  const filteredCities = CITIES.filter(c =>
    c.label.toLowerCase().includes(citySearch.toLowerCase())
  );

  // Step is complete if it has a value — used to allow clicking progress dots
  const stepComplete = (s) => {
    if (s === 0) return !!city;
    if (s === 1) return clientTypes.length > 0;
    if (s === 2) return !!expertise;
    if (s === 3) return specialties.length > 0;
    if (s === 4) return !!offer;
    if (s === 5) return true;
    return false;
  };

  const canNext = () => stepComplete(step);

  const calculate = () => {
    const ct = CITIES.find((c) => c.id === city);
    const cl = clientTypes.length > 0
      ? { multiplier: clientTypes.reduce((sum, id) => { const c = CLIENT_TYPES.find((x) => x.id === id); return sum + (c?.multiplier || 1); }, 0) / clientTypes.length, label: clientTypes.map((id) => CLIENT_TYPES.find((c) => c.id === id)?.label.replace(/^\S+\s/, "")).join(", ") }
      : { multiplier: 1, label: "Non précisé" };
    const exp = EXPERTISE_LEVELS.find((e) => e.id === expertise);
    const specBonus = specialties.length > 0
      ? Math.round(specialties.reduce((s, id) => { const x = SPECIALTIES.find((sp) => sp.id === id); return s + (x?.bonus || 0); }, 0) / specialties.length)
      : 0;
    const off = OFFERS.find((o) => o.id === offer);
    const extrasBonus = extras.reduce((s, id) => { const e = EXTRAS.find((ex) => ex.id === id); return s + (e?.bonus || 0); }, 0);
    const base = (exp[off.key] + specBonus + extrasBonus) * ct.multiplier * cl.multiplier;
    const low = Math.round((base * 0.85) / 10) * 10;
    const mid = Math.round(base / 10) * 10;
    const high = Math.round((base * 1.2) / 10) * 10;
    const newResult = {
      low, mid, high,
      unit: off.unit,
      city: ct.label,
      clientType: cl.label,
      expertise: exp.label,
      offer: off.label,
      specialtiesLabels: specialties.map((id) => SPECIALTIES.find((s) => s.id === id)?.label.replace(/^\S+\s/, "")),
    };
    setResult(newResult);
    setHistory((prev) => [...prev, newResult]);
    setStep(6);
  };

  const resetForm = () => {
    setStep(0); setCity(null); setCitySearch(""); setClientTypes([]);
    setExpertise(null); setSpecialties([]); setOffer(null); setExtras([]); setResult(null);
  };
  const fullReset = () => { resetForm(); setHistory([]); };

  return (
    <div style={{ minHeight: "100vh", background: "#f5f3ff", fontFamily: "'DM Sans', sans-serif", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", padding: "40px 16px 60px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Inter:wght@400;500;600;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .card { background: white; border-radius: 24px; box-shadow: 0 4px 40px rgba(109,40,217,0.10); }
        .chip { background: white; border: 2px solid #ede9fe; border-radius: 12px; padding: 10px 14px; cursor: pointer; transition: all 0.15s; text-align: left; width: 100%; font-family: 'DM Sans', sans-serif; }
        .chip:hover { border-color: #7c3aed; background: #faf5ff; }
        .chip.sel { border-color: #7c3aed; background: #faf5ff; box-shadow: 0 0 0 3px rgba(124,58,237,0.10); }
        .pill { border: 2px solid #ede9fe; border-radius: 999px; padding: 7px 16px; cursor: pointer; transition: all 0.15s; font-size: 13px; background: white; color: #6d28d9; font-family: 'DM Sans', sans-serif; }
        .pill:hover { border-color: #7c3aed; }
        .pill.sel { background: #7c3aed; border-color: #7c3aed; color: white; }
        .btn { background: #7c3aed; color: white; border: none; border-radius: 12px; padding: 13px 28px; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.15s; font-family: 'DM Sans', sans-serif; }
        .btn:hover:not(:disabled) { background: #6d28d9; transform: translateY(-1px); box-shadow: 0 6px 20px rgba(109,40,217,0.28); }
        .btn:disabled { opacity: 0.28; cursor: not-allowed; }
        .btn-out { background: transparent; color: #a78bfa; border: 2px solid #ede9fe; border-radius: 12px; padding: 11px 22px; font-size: 14px; cursor: pointer; transition: all 0.15s; font-family: 'DM Sans', sans-serif; }
        .btn-out:hover { border-color: #a78bfa; color: #7c3aed; }
        .btn-sm { background: transparent; color: #9ca3af; border: 2px solid #f3f4f6; border-radius: 10px; padding: 8px 16px; font-size: 12px; cursor: pointer; font-family: 'DM Sans', sans-serif; transition: all 0.15s; }
        .btn-sm:hover { border-color: #e5e7eb; color: #6b7280; }
        .src-link { display: flex; align-items: flex-start; gap: 8px; padding: 8px 10px; border-radius: 8px; text-decoration: none; transition: background 0.12s; }
        .src-link:hover { background: #ede9fe; }
        .city-search { width: 100%; border: 2px solid #ede9fe; border-radius: 12px; padding: 10px 14px; font-size: 14px; font-family: 'DM Sans', sans-serif; outline: none; color: #1e1b4b; transition: border 0.15s; }
        .city-search:focus { border-color: #7c3aed; }
        .city-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 8px; max-height: 280px; overflow-y: auto; padding-right: 4px; }
        .city-grid::-webkit-scrollbar { width: 4px; }
        .city-grid::-webkit-scrollbar-thumb { background: #c4b5fd; border-radius: 4px; }
        .step-dot { cursor: pointer; transition: all 0.25s; border-radius: 999px; }
        .step-dot:hover { opacity: 1 !important; }
        .cmp-table { width: 100%; border-collapse: collapse; font-size: 13px; }
        .cmp-table th { background: #faf5ff; color: #7c3aed; font-family: 'Inter', sans-serif; font-weight: 800; font-size: 11px; letter-spacing: 0.08em; text-transform: uppercase; padding: 10px 12px; text-align: left; border-bottom: 2px solid #ede9fe; white-space: nowrap; }
        .cmp-table td { padding: 10px 12px; border-bottom: 1px solid #f3f4f6; color: #374151; vertical-align: middle; }
        .cmp-table tr:last-child td { border-bottom: none; }
        .cmp-table tr:hover td { background: #faf5ff; }
        .num { font-family: 'Inter', sans-serif; font-weight: 800; letter-spacing: -0.02em; }
        @keyframes up { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        .anim { animation: up 0.32s ease forwards; }
      `}</style>

      {/* GATE SCREEN */}
      {gated && (
        <div className="anim" style={{ width: "100%", maxWidth: 520, display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginTop: 20 }}>
          <div style={{ display: "inline-block", background: "#ede9fe", color: "#7c3aed", borderRadius: 999, padding: "5px 16px", fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 16 }}>
            ✦ Freelance Pricing Tool
          </div>
          <h1 style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(26px, 6vw, 42px)", fontWeight: 800, lineHeight: 1.08, color: "#1e1b4b", letterSpacing: "-0.03em", marginBottom: 14 }}>
            Combien vaut<br />
            <span style={{ background: "linear-gradient(135deg, #7c3aed, #a78bfa)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>ton expertise ?</span>
          </h1>

          <div className="card" style={{ width: "100%", padding: "28px 24px", marginBottom: 16 }}>
            <div style={{ width: 44, height: 44, background: "linear-gradient(135deg, #7c3aed, #a78bfa)", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, margin: "0 auto 16px" }}>💡</div>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontSize: 19, fontWeight: 800, color: "#1e1b4b", letterSpacing: "-0.02em", marginBottom: 10 }}>
              Avant d'accéder au calculateur…
            </h2>
            <p style={{ fontSize: 14, color: "#6b7280", lineHeight: 1.75, marginBottom: 22 }}>
              J'ai créé cet outil gratuitement pour t'aider à mieux te pricer. En échange, j'ai juste une question : <strong style={{ color: "#1e1b4b" }}>c'est quoi ton vrai blocage en tant que communicant·e, marketeur·se ou designer freelance ?</strong>
              <br /><br />
              4 questions, 1 minute chrono — je ne te demande pas ton email et je n'ai pas de produit ou de service à te vendre. Tes réponses m'aident juste à créer les ressources dont tu as vraiment besoin. 🙂
            </p>

            {/* Étapes visuelles */}
            <div style={{ display: "flex", justifyContent: "center", gap: 24, marginBottom: 24 }}>
              {["1 min", "4 questions", "100% gratuit"].map((item, i) => (
                <div key={i} style={{ textAlign: "center" }}>
                  <div style={{ width: 36, height: 36, background: "#faf5ff", border: "2px solid #ede9fe", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14, margin: "0 auto 6px" }}>
                    {["⚡", "✍️", "🎁"][i]}
                  </div>
                  <p style={{ fontSize: 11, color: "#7c3aed", fontWeight: 700 }}>{item}</p>
                </div>
              ))}
            </div>

            <a
              href="https://www.notion.so/dianemasse/327f94f3e16580f1b73cd994533fe99a?pvs=106"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setTimeout(() => setGated(false), 800)}
              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "white", borderRadius: 12, padding: "14px 24px", fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 15, textDecoration: "none", marginBottom: 16 }}
              onMouseEnter={e => e.currentTarget.style.background = "#6d28d9"}
              onMouseLeave={e => e.currentTarget.style.background = "#7c3aed"}
            >
              Répondre au questionnaire →
            </a>

            <button
              onClick={() => setGated(false)}
              style={{ background: "none", border: "none", color: "#c4b5fd", fontSize: 12, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", textDecoration: "underline", padding: "4px" }}
            >
              Passer et accéder directement au calculateur
            </button>
          </div>
        </div>
      )}

      {/* CALCULATOR — masqué tant que gated est true */}
      {!gated && <>

      {/* Header */}
      <div className="anim" style={{ textAlign: "center", marginBottom: 28, maxWidth: 520 }}>
        <div style={{ display: "inline-block", background: "#ede9fe", color: "#7c3aed", borderRadius: 999, padding: "5px 16px", fontSize: 11, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: 14 }}>
          ✦ Freelance Pricing Tool
        </div>
        <h1 style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(26px, 6vw, 44px)", fontWeight: 800, lineHeight: 1.08, color: "#1e1b4b", letterSpacing: "-0.03em" }}>
          Combien vaut<br />
          <span style={{ background: "linear-gradient(135deg, #7c3aed, #a78bfa)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>ton expertise ?</span>
        </h1>
        <p style={{ color: "#6b7280", fontSize: 14, marginTop: 10, lineHeight: 1.6 }}>
          6 étapes pour fixer un tarif juste — sans te sous-vendre.
        </p>
      </div>

      {/* Progress — cliquable sur les étapes déjà complétées */}
      <div style={{ display: "flex", gap: 5, alignItems: "center", marginBottom: 8 }}>
        {STEPS.map((label, i) => {
          const isDone = i < step && stepComplete(i);
          const isCurrent = i === step;
          const isClickable = isDone;
          return (
            <div
              key={i}
              className="step-dot"
              title={isClickable ? `Modifier : ${label}` : label}
              onClick={() => isClickable && setStep(i)}
              style={{
                height: 7,
                width: isCurrent ? 24 : 7,
                background: isCurrent ? "#7c3aed" : isDone ? "#a78bfa" : "#e5e7eb",
                opacity: i <= step ? 1 : 0.35,
                cursor: isClickable ? "pointer" : "default",
              }}
            />
          );
        })}
      </div>
      {/* Hint navigation */}
      {step > 0 && step < 6 && (
        <p style={{ fontSize: 11, color: "#c4b5fd", marginBottom: 18, textAlign: "center" }}>
          ✦ Clique sur un point violet pour modifier une étape précédente
        </p>
      )}
      {(step === 0 || step === 6) && <div style={{ marginBottom: 18 }} />}

      {/* Main card */}
      <div className="card" style={{ width: "100%", maxWidth: 600, padding: "28px 24px" }}>

        {/* STEP 0 — Ville */}
        {step === 0 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 1 / 6</p>
            <H2>Ta ville la plus proche</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 14 }}>Le TJM est plus élevé en région parisienne qu'en province.</p>
            <input className="city-search" placeholder="🔍 Recherche ta ville..." value={citySearch} onChange={(e) => setCitySearch(e.target.value)} style={{ marginBottom: 12 }} />
            <div className="city-grid">
              {filteredCities.map((c) => (
                <button key={c.id} className={`chip ${city === c.id ? "sel" : ""}`} onClick={() => setCity(c.id)}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: "#1e1b4b" }}>{c.label}</div>
                  <div style={{ fontSize: 10, color: c.multiplier > 1 ? "#7c3aed" : "#9ca3af", marginTop: 2 }}>
                    {c.multiplier > 1 ? `+${Math.round((c.multiplier - 1) * 100)}%` : "Base"}
                  </div>
                </button>
              ))}
              {filteredCities.length === 0 && <p style={{ color: "#9ca3af", fontSize: 13, gridColumn: "1/-1", padding: "12px 0" }}>Aucune ville trouvée.</p>}
            </div>
          </div>
        )}

        {/* STEP 1 — Type de client */}
        {step === 1 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 2 / 6</p>
            <H2>Ton type de client cible</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 14 }}>Sélectionne-en plusieurs si tu as des cibles variées — le tarif sera calculé en moyenne.</p>

            {/* Note d'information */}
            <div style={{ background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 10, padding: "10px 14px", marginBottom: 16, display: "flex", gap: 8, alignItems: "flex-start" }}>
              <span style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }}>⚠️</span>
              <p style={{ fontSize: 12, color: "#92400e", lineHeight: 1.6 }}>
                <strong>Attention :</strong> en fonction des cibles, les budgets peuvent être très variables. Un grand groupe peut accepter un TJM 2× plus élevé qu'une TPE pour une mission identique. Ces multiplicateurs sont des moyennes indicatives — ajuste toujours selon le contexte réel du client.
              </p>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 9 }}>
              {CLIENT_TYPES.map((c) => (
                <button key={c.id} className={`chip ${clientTypes.includes(c.id) ? "sel" : ""}`} onClick={() => toggleClientType(c.id)}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: "#1e1b4b" }}>{c.label}</div>
                  <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>{c.desc}</div>
                  <div style={{ fontSize: 10, color: c.multiplier >= 1 ? "#7c3aed" : "#f59e0b", marginTop: 3, fontWeight: 600 }}>
                    {c.multiplier > 1 ? `+${Math.round((c.multiplier - 1) * 100)}%` : c.multiplier === 1 ? "Base" : `−${Math.round((1 - c.multiplier) * 100)}%`}
                  </div>
                </button>
              ))}
            </div>
            <p style={{ fontSize: 12, color: "#c4b5fd", marginTop: 14 }}>
              {clientTypes.length === 0 ? "Sélectionne au moins un type de client." : `${clientTypes.length} cible${clientTypes.length > 1 ? "s" : ""} sélectionnée${clientTypes.length > 1 ? "s" : ""} ✦`}
            </p>
          </div>
        )}

        {/* STEP 2 — Expérience */}
        {step === 2 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 3 / 6</p>
            <H2>Ton niveau d'expérience</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 18 }}>Données Malt & ABC Portage — marché freelance FR 2025.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
              {EXPERTISE_LEVELS.map((e) => (
                <button key={e.id} className={`chip ${expertise === e.id ? "sel" : ""}`} onClick={() => setExpertise(e.id)}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 15, color: "#1e1b4b" }}>{e.label}</div>
                      <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{e.years}</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontSize: 11, color: "#7c3aed", fontWeight: 600 }}>{e.note}</div>
                      <div style={{ width: 9, height: 9, borderRadius: "50%", background: expertise === e.id ? e.color : "#e5e7eb", marginLeft: "auto", marginTop: 5, transition: "background 0.18s" }} />
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* STEP 3 — Spécialités */}
        {step === 3 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 4 / 6</p>
            <H2>Tes spécialités</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 16 }}>Sélectionne-en plusieurs — le bonus sera calculé en moyenne.</p>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              {SPECIALTIES.map((s) => (
                <button key={s.id} className={`chip ${specialties.includes(s.id) ? "sel" : ""}`} onClick={() => toggleSpecialty(s.id)}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: "#1e1b4b" }}>{s.label}</div>
                  <div style={{ fontSize: 10, color: s.bonus > 0 ? "#7c3aed" : "#9ca3af", marginTop: 2 }}>{s.bonus > 0 ? "+ valorisé" : "Base"}</div>
                </button>
              ))}
            </div>
            <p style={{ fontSize: 12, color: "#c4b5fd", marginTop: 14 }}>
              {specialties.length === 0 ? "Sélectionne au moins une spécialité." : `${specialties.length} spécialité${specialties.length > 1 ? "s" : ""} ✦`}
            </p>
          </div>
        )}

        {/* STEP 4 — Offre */}
        {step === 4 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 5 / 6</p>
            <H2>Type d'offre à pricer</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 18 }}>Chaque format a sa propre logique tarifaire.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
              {OFFERS.map((o) => (
                <button key={o.id} className={`chip ${offer === o.id ? "sel" : ""}`} onClick={() => setOffer(o.id)}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: "#1e1b4b" }}>{o.label}</div>
                      <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{o.desc}</div>
                    </div>
                    <div style={{ fontSize: 12, color: "#a78bfa", fontWeight: 600, whiteSpace: "nowrap", marginLeft: 12 }}>{o.unit}</div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* STEP 5 — Atouts */}
        {step === 5 && (
          <div className="anim">
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#a78bfa", marginBottom: 6 }}>Étape 6 / 6</p>
            <H2>Tes atouts différenciants</H2>
            <p style={{ color: "#9ca3af", fontSize: 13, marginBottom: 18 }}>Chaque atout légitime un tarif plus élevé.</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 9 }}>
              {EXTRAS.map((e) => (
                <button key={e.id} className={`pill ${extras.includes(e.id) ? "sel" : ""}`} onClick={() => toggleExtra(e.id)}>
                  {extras.includes(e.id) ? "✓ " : ""}{e.label}
                </button>
              ))}
            </div>
            <p style={{ fontSize: 12, color: "#c4b5fd", marginTop: 18 }}>
              {extras.length === 0 ? "Tu peux continuer sans sélectionner d'atout." : `${extras.length} atout${extras.length > 1 ? "s" : ""} ✦`}
            </p>
          </div>
        )}

        {/* STEP 6 — Résultat */}
        {step === 6 && result && (
          <div className="anim" style={{ textAlign: "center" }}>
            <div style={{ background: "linear-gradient(135deg, #5b21b6, #7c3aed, #a78bfa)", borderRadius: 18, padding: "26px 20px", marginBottom: 18, color: "white" }}>
              <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.16em", textTransform: "uppercase", opacity: 0.72, marginBottom: 6 }}>Ton tarif recommandé</p>
              <div style={{ fontFamily: "'Inter', sans-serif", fontSize: "clamp(52px, 13vw, 80px)", fontWeight: 800, lineHeight: 1, letterSpacing: "-0.03em" }}>
                {result.mid}€
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, opacity: 0.82, marginTop: 6 }}>{result.unit}</div>
              <div style={{ fontSize: 11, opacity: 0.6, marginTop: 8 }}>{result.city} · {result.clientType} · {result.expertise}</div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 14 }}>
              <div style={{ background: "#f9fafb", borderRadius: 12, padding: "13px" }}>
                <p style={{ fontSize: 10, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 5 }}>Plancher</p>
                <p className="num" style={{ fontSize: 24, color: "#6b7280" }}>{result.low}€</p>
                <p style={{ fontSize: 10, color: "#d1d5db", marginTop: 3 }}>Ne descends pas en dessous</p>
              </div>
              <div style={{ background: "#faf5ff", borderRadius: 12, padding: "13px" }}>
                <p style={{ fontSize: 10, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 5 }}>Ambitieux</p>
                <p className="num" style={{ fontSize: 24, color: "#7c3aed" }}>{result.high}€</p>
                <p style={{ fontSize: 10, color: "#c4b5fd", marginTop: 3 }}>Avec track record solide</p>
              </div>
            </div>

            <div style={{ background: "#faf5ff", border: "2px solid #ede9fe", borderRadius: 12, padding: "13px 16px", textAlign: "left", marginBottom: 14 }}>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 800, color: "#7c3aed", textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>À retenir ✦</p>
              <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.85 }}>
                → Ce tarif est un <strong style={{ color: "#1e1b4b" }}>point de départ calibré</strong> sur le marché FR 2025.<br />
                → Tarif de lancement possible — mais jamais moitié prix.<br />
                → Revois tes tarifs à la hausse tous les 6 mois.
              </p>
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              <button className="btn" onClick={resetForm} style={{ flex: 1, fontSize: 13 }}>＋ Tester une autre config</button>
              {history.length > 1 && (
                <button className="btn-sm" onClick={() => document.getElementById("recap").scrollIntoView({ behavior: "smooth" })}>Voir le récap ↓</button>
              )}
            </div>

            <div style={{ border: "2px solid #ede9fe", borderRadius: 12, overflow: "hidden", marginBottom: 12 }}>
              <button onClick={() => setShowSources(s => !s)} style={{ width: "100%", background: "none", border: "none", padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 800, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.1em" }}>
                <span>📎 Sources & données</span>
                <span style={{ color: "#c4b5fd" }}>{showSources ? "▲" : "▼"}</span>
              </button>
              {showSources && (
                <div style={{ padding: "0 6px 10px", borderTop: "1px solid #f3f4f6" }}>
                  {SOURCES.map((s, i) => (
                    <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="src-link">
                      <span style={{ color: "#7c3aed", fontSize: 13, flexShrink: 0 }}>→</span>
                      <span style={{ fontSize: 12, color: "#6d28d9", lineHeight: 1.5 }}>{s.label}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <button className="btn-sm" onClick={fullReset} style={{ width: "100%", padding: "10px" }}>🗑 Tout réinitialiser</button>
          </div>
        )}

        {/* Navigation */}
        {step < 6 && (
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 24 }}>
            <button className="btn-out" onClick={() => setStep((s) => s - 1)} style={{ visibility: step === 0 ? "hidden" : "visible" }}>← Retour</button>
            {step < 5 ? (
              <button className="btn" disabled={!canNext()} onClick={() => setStep((s) => s + 1)}>Suivant →</button>
            ) : (
              <button className="btn" onClick={calculate}>Calculer mon tarif ✦</button>
            )}
          </div>
        )}
      </div>

      {/* Encart questionnaire — visible à toutes les étapes */}
      <div style={{ width: "100%", maxWidth: 600, marginTop: 16, background: "linear-gradient(135deg, #faf5ff, #ede9fe)", border: "2px solid #ddd6fe", borderRadius: 16, padding: "18px 20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <div style={{ width: 34, height: 34, background: "#7c3aed", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>💡</div>
          <div>
            <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 800, fontSize: 14, color: "#1e1b4b", letterSpacing: "-0.01em" }}>Et toi, c'est quoi ton vrai blocage ?</p>
            <p style={{ fontSize: 12, color: "#7c3aed", marginTop: 1 }}>1 minute · 4 questions</p>
          </div>
        </div>
        <p style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.7, marginBottom: 14 }}>
          Tu viens de calculer tes tarifs, maintenant dis-moi ce qui te bloque vraiment dans ton activité. Tes réponses m'aident à créer les ressources et formations dont tu as vraiment besoin — promis, j'ai rien à te vendre. 🙂
        </p>
        <a
          href="https://www.notion.so/dianemasse/327f94f3e16580f1b73cd994533fe99a?pvs=106"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "white", borderRadius: 12, padding: "12px 20px", fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 14, textDecoration: "none" }}
          onMouseEnter={e => e.currentTarget.style.background = "#6d28d9"}
          onMouseLeave={e => e.currentTarget.style.background = "#7c3aed"}
        >
          Répondre au questionnaire →
        </a>
      </div>

      {/* TABLEAU COMPARATIF */}
      {history.length > 1 && (
        <div id="recap" className="anim card" style={{ width: "100%", maxWidth: 600, marginTop: 28, padding: "24px 20px", overflowX: "auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontSize: 17, fontWeight: 800, color: "#1e1b4b", letterSpacing: "-0.02em" }}>📊 Comparatif de tes simulations</h2>
            <Tag label={`${history.length} configs`} />
          </div>
          <div style={{ overflowX: "auto" }}>
            <table className="cmp-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Ville</th>
                  <th>Client</th>
                  <th>Niveau</th>
                  <th>Offre</th>
                  <th>Plancher</th>
                  <th>Recommandé</th>
                  <th>Ambitieux</th>
                </tr>
              </thead>
              <tbody>
                {history.map((h, i) => (
                  <tr key={i}>
                    <td><Tag label={`#${i + 1}`} /></td>
                    <td style={{ color: "#6b7280", fontSize: 12 }}>{h.city}</td>
                    <td style={{ color: "#6b7280", fontSize: 12 }}>{h.clientType}</td>
                    <td style={{ color: "#6b7280", fontSize: 12 }}>{h.expertise}</td>
                    <td style={{ color: "#6b7280", fontSize: 12 }}>{h.offer}</td>
                    <td><span className="num" style={{ fontSize: 14, color: "#9ca3af" }}>{h.low}€</span></td>
                    <td>
                      <span className="num" style={{ fontSize: 16, color: "#7c3aed" }}>{h.mid}€</span>
                      <span style={{ fontSize: 10, color: "#c4b5fd", marginLeft: 3 }}>{h.unit}</span>
                    </td>
                    <td><span className="num" style={{ fontSize: 14, color: "#10b981" }}>{h.high}€</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {history.length >= 2 && (() => {
            const best = history.reduce((a, b) => a.mid > b.mid ? a : b);
            return (
              <p style={{ fontSize: 12, color: "#7c3aed", marginTop: 14, background: "#faf5ff", borderRadius: 8, padding: "8px 12px" }}>
                ✦ Ta config la plus rentable : <strong>{best.city} · {best.clientType} · {best.expertise} · {best.offer}</strong> → <strong>{best.mid}€ {best.unit}</strong>
              </p>
            );
          })()}
        </div>
      )}

      <p style={{ marginTop: 24, fontSize: 11, color: "#c4b5fd", textAlign: "center" }}>
        Outil créé par <a href="https://www.linkedin.com/in/dianemasse/" target="_blank" rel="noopener noreferrer" style={{ color: "#a78bfa", fontWeight: 700, textDecoration: "none" }}>Diane Massé</a> · Données Malt, ABC Portage, 2iPortage, Jedha, Koino — FR 2025/2026
      </p>

      </>} {/* end !gated */}
    </div>
  );
}